export default __webpack_public_path__ + "audio/bd9b718df69aaed4abda12c19735a92d.mp3";